/* ═══════════════════════════════════════════════════════════
   gc-post ── 文章頁的自動化（2026-08-30）

   ── 為什麼要 JS ──
   文章內容是 Mars 在後台編輯器打的，Liquid 只拿得到一整包 HTML，
   沒辦法在伺服器端知道「這篇有幾個章節」「哪裡有表格」。
   所以目錄、表格捲軸、FAQ 手風琴都在瀏覽器這邊自動長出來——
   **寫文章的人什麼都不用做**，照平常打字就好。

   要寫作時自己貼的只有重點框（四種），格式寫在 section 的說明裡。

   ── 一個原則 ──
   每一段都「找不到就安靜跳過」。文章沒有 h2 就不出現目錄、
   沒有表格就不包捲軸——不可以因為缺一樣東西就整頁壞掉。
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.querySelector('.gc-post');
  if (!root || root.dataset.gcpInit) return;
  root.dataset.gcpInit = '1';

  var body = root.querySelector('.gc-post__body');
  if (!body) return;

  /* ── ⑥ 表格：包一層橫向捲軸 ──
     直接對 table 設 overflow 沒有作用，一定要外面包一層容器。
     不包的話窄畫面會被整張表撐寬，整頁出現橫向捲動。 */
  Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
    if (t.parentNode && t.parentNode.classList.contains('gc-post__tw')) return;
    var w = document.createElement('div');
    w.className = 'gc-post__tw';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* ── ⑧ 文中商品卡：搬到第 N 個章節後面 ──
     Liquid 拿到的是一整包 HTML，沒辦法在伺服器端插進文章中間，
     所以先渲染在文章最後面，這裡再搬。
     章節不夠多就原地不動——寧可留在最後面，也不要硬塞進第一段前面。
     一定要在 FAQ 之前跑：FAQ 會把節點搬走，之後 h2 的順序就不是原本的了。 */
  (function moveCard () {
    var card = root.querySelector('[data-gcp-card]');
    if (!card) return;
    var after = parseInt(card.getAttribute('data-gcp-after'), 10);
    if (!after || after < 1) return;
    var hs = body.querySelectorAll('h2');
    if (hs.length <= after) return;          // 章節不夠，留在原地
    hs[after].parentNode.insertBefore(card, hs[after]);
  })();

  /* ── ⑨ FAQ 手風琴 ──
     找一個標題寫著「常見問題 / FAQ / Q&A」的 h2，把它後面到下一個 h2
     之間的內容，依 h3 拆成一問一答收起來。
     沒有這種標題就整段不做——不要自作聰明把普通章節收起來。 */
  (function buildFaq () {
    var hs = body.querySelectorAll('h2');
    var mark = null;
    for (var i = 0; i < hs.length; i++) {
      if (/常見問題|常見問答|問與答|FAQ|Q\s*&\s*A/i.test(hs[i].textContent)) { mark = hs[i]; break; }
    }
    if (!mark) return;

    // 收集這個 h2 之後、下一個 h2 之前的所有節點
    var chunk = [], n = mark.nextElementSibling;
    while (n && n.tagName !== 'H2') { chunk.push(n); n = n.nextElementSibling; }
    // 至少要有一個 h3 才值得做成手風琴
    if (!chunk.some(function (e) { return e.tagName === 'H3'; })) return;

    // 標題**留在內文流裡**（跟其他章節一樣的 h2），卡片接在它後面。
    // 第一版把標題也塞進卡片、卡片再加一條上框線，結果上面文章本來就有
    // 一條 <hr>，畫面上變成兩條線夾一片空白（2026-08-30 Mars 截圖抓到）。
    var wrap = document.createElement('div');
    wrap.className = 'gc-post__faq';
    mark.parentNode.insertBefore(wrap, mark.nextSibling);

    var qa = [], cur = null;
    chunk.forEach(function (el) {
      if (el.tagName === 'H3') {
        cur = { q: el.textContent.trim(), a: [] };
        qa.push(cur);
      } else if (cur) {
        cur.a.push(el);
      }
    });

    qa.forEach(function (item) {
      var d = document.createElement('details');
      var s = document.createElement('summary');
      s.textContent = item.q;
      var a = document.createElement('div');
      a.className = 'gc-post__faq__a';
      item.a.forEach(function (el) { a.appendChild(el); });
      d.appendChild(s); d.appendChild(a);
      wrap.appendChild(d);
    });
    // 原本的 h3 已經被搬進 summary 的文字裡，剩下的空殼要清掉
    chunk.forEach(function (el) {
      if (el.tagName === 'H3' && el.parentNode) el.parentNode.removeChild(el);
    });

    /* FAQPage 結構化資料：讓 Google 有機會吃到「常見問題」那個版位。
       注意這是 JS 產生的——Google 會執行 JS 所以讀得到，但比伺服器端算的慢一步。
       文章內容存在編輯器裡、Liquid 拆不出問答，只能在這邊做。 */
    if (qa.length) {
      var ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: qa.map(function (x) {
          return {
            '@type': 'Question',
            name: x.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: x.a.map(function (e) { return e.textContent.trim(); }).join(' ').slice(0, 900)
            }
          };
        })
      });
      document.head.appendChild(ld);
    }
  })();

  /* ── ① 目錄：從 h2／h3 自動長出來 ──
     FAQ 那一段跑完才做目錄，順序不能反——不然目錄會指到已經被搬走的標題。 */
  var toc = root.querySelector('[data-gcp-toc]');
  var links = [], heads = [];

  if (toc) {
    var hs2 = body.querySelectorAll('h2, h3');
    var ol = document.createElement('ol');
    var seen = {};

    Array.prototype.forEach.call(hs2, function (h) {
      var txt = h.textContent.trim();
      if (!txt) return;
      if (!h.id) {
        // 中文沒辦法轉成好看的英文 id，用序號就好——目錄只要點得到，不必好看
        var base = 'gcp-' + (h.tagName === 'H3' ? 's' : 'h') + (heads.length + 1);
        while (seen[base]) base += 'x';
        seen[base] = 1;
        h.id = base;
      }
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'lv3';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = txt;
      li.appendChild(a); ol.appendChild(li);
      heads.push(h); links.push(a);
    });

    // 少於兩個章節不值得放目錄——一條孤零零的連結只是噪音
    if (heads.length >= 2) {
      toc.appendChild(ol);
      toc.hidden = false;
    }
  }

  /* ── 進度條 ＋ 目錄跟著捲動變色 ──
     量到的數字要快取，只在視窗寬變了才重算：
     每一幀都 getBoundingClientRect() 會讓長文章明顯卡頓。 */
  var bar = root.querySelector('[data-gcp-bar]');
  var tops = [], docH = 0, ticking = false;

  function measure () {
    tops = heads.map(function (h) { return h.getBoundingClientRect().top + window.pageYOffset; });
    var r = body.getBoundingClientRect();
    var start = r.top + window.pageYOffset;
    docH = Math.max(1, r.height - window.innerHeight * 0.6);
    measure.start = start;
  }

  function frame () {
    ticking = false;
    var y = window.pageYOffset;

    if (bar) {
      var pct = (y - measure.start) / docH;
      bar.style.width = Math.max(0, Math.min(1, pct)) * 100 + '%';
    }

    if (links.length) {
      var at = 0;
      for (var i = 0; i < tops.length; i++) {
        if (tops[i] - 90 <= y) at = i; else break;
      }
      for (var j = 0; j < links.length; j++) {
        links[j].classList.toggle('is-on', j === at);
      }
    }
  }

  function onScroll () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }

  var lastW = window.innerWidth;
  function onResize () {
    // 手機捲動時網址列縮放會觸發 resize，寬度沒變就不要重算
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    measure(); onScroll();
  }

  measure();
  onScroll();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onResize);
  // 圖片載完高度才是準的，不重量的話進度條會提早跑到底
  addEventListener('load', function () { measure(); onScroll(); });
})();
